import {} from "querystring";

export const REQUEST_PATHS = {
  // TODO(ohashi): 正式なエンドポイントに修正
  HEAT_MAP: "/test",
  SEEK_THUMBNAIL: `${process.env.NEXT_PUBLIC_THUMBNAIL_ENDPOINT}/v3/thumbnail/content/[contentId]`,
  PLAYER_LOGGING: "https://pigeon.i3.dmm.com/v2/dig_player_log/play/video",
  BEACON: "https://development.beacon.dmm.com/streaming/start",
  CONVERSION_API: "https://www.dmm.com/marketing/api/-/conversion/",
  AFFILIATE_API: "https://www.dmm.com/marketing/api/-/affiliate/=/name=link/",
  TRACKING_API: process.env.NEXT_PUBLIC_TRACKING_ENDPOINT,
} as const;

type PathKey = keyof typeof REQUEST_PATHS;
type Path = (typeof REQUEST_PATHS)[PathKey];

type WithoutSlash<T> = T extends `/${infer U}` ? U : never;
type Resource<T> = T extends `${infer U}/${infer S}` ? U | Resource<S> : T;
type DynamicRoute<T> = T extends `[${infer U}]` ? U : never;

type Params<T> = DynamicRoute<Resource<WithoutSlash<T>>>;
type ParamKeys<T extends Path> = Params<T>;

type PathParams<T extends Path> = {
  path: T;
  params?: { [K in ParamKeys<T>]: string | number };
};

type Args<T extends Path> = ParamKeys<T> extends never ? PathParams<T> : Required<PathParams<T>>;

export type RequestPaths = (typeof REQUEST_PATHS)[keyof typeof REQUEST_PATHS];

export function createPath<T extends Path>({ path, params }: Args<T>) {
  if (!params) return path;

  return path
    .split("/")
    .map((str) => {
      const match = str.match(/\[(.*?)\]/);
      if (match) {
        const key = match[0];
        const trimmed = key.substring(1, key.length - 1) as ParamKeys<typeof path>;
        return params[trimmed];
      }
      return str;
    })
    .join("/");
}
